import React from 'react'
import {Create} from "@mui/icons-material"

function SideBarOpt({icon,label}) {
  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
        <Create/>
        <p>Create Tariff</p>
    </div>
  )
}

export default SideBarOpt